module.exports = __webpack_public_path__ + "static/fipcmusicalbearmain-bc6f5485e57b8da42dbf7c30998083c2.jpeg";